module.exports = __webpack_public_path__ + "img/poster-1.1db769c3.jpg";